import { 
    initGlobalState
  } from 'qiankun';
  import * as zeusRouter from '../share/zeusRouter'
  import store from "../store/index"
  let initialState = store.getState()
  const actions = initGlobalState(initialState)
  
  actions.onGlobalStateChange((newState, prev) => {
    initialState = newState
  })
  actions.zeusRouter = () => {
    return zeusRouter
  }
  // 定义一个获取state的方法下发到子应用
  actions.getGlobalState = key => {
    return key ? initialState[key] : initialState
  }
  export default actions